var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fux-popup"},[(_vm.user && _vm.scriptLoaded)?[_c('router-view',{key:_vm.$route.fullPath})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }